"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePageTracking;

var _react = require("react");

var _useSiteTracking = require("./useSiteTracking");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function usePageTracking(pageData) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$trackPageViewByD = _ref.trackPageViewByDefault,
      trackPageViewByDefault = _ref$trackPageViewByD === void 0 ? true : _ref$trackPageViewByD;

  var _useContext = (0, _react.useContext)(_useSiteTracking.SiteTrackingContext),
      getSiteData = _useContext.getSiteData,
      getPageTracking = _useContext.getPageTracking,
      getEventTracking = _useContext.getEventTracking,
      setPageData = _useContext.setPageData,
      getPageData = _useContext.getPageData;

  setPageData(pageData);
  var trackPageView = (0, _react.useCallback)(function () {
    var pageTracking = getPageTracking();

    if (typeof pageTracking.trackPageView === "function") {
      pageTracking.trackPageView({
        siteData: getSiteData(),
        pageData: getPageData()
      });
    } else {
      console.error("react-event-tracker: pageTracking.trackPageView must be a function");
    }
  }, [getPageTracking, getSiteData, getPageData]);
  (0, _react.useEffect)(function () {
    if (trackPageViewByDefault === true) {
      trackPageView();
    }
  }, [trackPageViewByDefault, trackPageView]);
  var result = (0, _react.useMemo)(function () {
    var eventTracking = getEventTracking();
    return Object.keys(eventTracking).reduce(function (acc, key) {
      acc[key] = function (eventData) {
        if (typeof eventTracking[key] === "function") {
          var siteData = getSiteData();

          var _pageData = getPageData();

          return eventTracking[key]({
            siteData: siteData,
            pageData: _pageData,
            eventData: eventData
          });
        }
      };

      return acc;
    }, {});
  }, [getSiteData, getEventTracking, getPageData]);
  return _objectSpread(_objectSpread({}, result), {}, {
    trackPageView: trackPageView
  });
}